module.exports = __webpack_public_path__ + "static/media/arrow_right.7fb90b2b.svg";